/* eslint-disable max-len */
const koKr = {
  CancellationRequest: '취소 요청',
  Heading: '다음 정보를 제공해 주세요. 모든 필드를 입력해 주세요.',
  Note: '예약 취소가 필요하신가요? 친절히 도와드리겠습니다. 취소하려는 예약에 대해 아래 필드를 작성해 주세요.',
  PartnerNote:
    '감사합니다! 여행이 가장 임박한 요청을 우선적으로 처리하고 있으니 양해 부탁드립니다. 여행 날짜 전에 취소가 확인되지 않았다면 현재 처리 중입니다. 고객님께서 하실 일은 없습니다.',
  SubmitNote:
    '대량의 여행 중단으로 인해 지급 처리가 지연될 수 있습니다. 불편을 드려 죄송하며, 양해해 주셔서 미리 감사드립니다.',
  Disclaimer:
    '중요: 이 양식은 여행 날짜가 2021년 12월 31일까지인 경우에만 사용 가능합니다.',
  Itin: '일정 번호(일정 또는 확인 이메일에 나와 있는 11~15자)',
  EmailAddress: '이 예약에 사용된 이메일 주소',
  PhoneNumber: '이 예약에 사용된 전화번호',
  Reason: '이유',
  Submit: '계속',
  Success: '요청이 접수되었습니다.',
  Failed: '죄송합니다!',
  InProgress: '현재 처리 중입니다.',
  TryAgain: '돌아가기',
  PhoneErrorMessage: '유효한 전화번호를 입력해 주세요.',
  EmailErrorMessage: '유효한 이메일 주소를 입력해 주세요.',
  ItinErrorMessage: '유효한 일정 번호를 입력해 주세요.',
  ResponseEligibleHeader: '해당 일정을 찾았습니다.',
  ResponseEligibleSubmit: '예약 취소',
  ResponseEligibleNeverMind: '취소 안 함',
  ResponseOnlyLodgingWithRefund:
    '환불이 가능한 숙박 시설 예약이 {x}개 있습니다. 취소를 선택하시면 예약 시 사용하신 결제 방법으로 환불해 드립니다.',
  ResponseOnlyLodgingWithCoupon:
    '쿠폰 형태의 바우처를 받을 수 있는 숙박 시설 예약이 {x}개 있습니다. 취소를 선택하시면 원래 구매 금액에 해당하는 쿠폰을 발행해 드립니다.',
  ResponseOnlyLodgingInEligible:
    '무료 취소가 불가능한 숙박 시설 예약이 {x}개 있습니다. 취소를 선택하시면 저희 숙박 시설 파트너사의 표준 취소 정책이 적용됩니다.',
  ResponseLodgingWithOtherLob:
    '이 일정과 관련된 기타 모든 예약에는 파트너사의 정책이 적용됩니다.',
  ResponseNoLodgingWithOtherLob:
    '이 일정과 관련된 모든 예약에는 파트너사의 정책이 적용됩니다.',
  ResponseAlreadyCancelled:
    '이미 취소된 숙박 시설 예약이 {x}개 있습니다. 대량의 여행 중단으로 인해 지급 처리가 지연될 수 있습니다. 궁금하신 점이 있으신 경우 고객 지원으로 문의해 주세요.',
  ResponseNoFlexAvailable:
    '환불 또는 바우처가 제공되지 않는 숙박 시설 예약이 {x}개 있습니다. 지금 취소하시면 저희 숙박 시설 파트너사의 표준 취소 정책이 적용됩니다. 그러나 취소 정책은 변경될 수 있습니다. 여행 시작 8일 전에 최신 취소 정책을 다시 확인해 주세요.',
  ResponseInvalidDuplicateItinerary:
    '이 요청을 이미 제출하신 것 같습니다. 여행이 가장 임박한 요청을 우선적으로 처리하고 있으니 양해 부탁드립니다. 여행 날짜 전에 취소가 확인되지 않았다면 현재 처리 중입니다. 고객님께서 하실 일은 없습니다.',
  ResponseElligibleConfirmation: '예약을 취소하시겠어요?',
  ResponseInvalidUnknown:
    '해당 일정 번호 또는 확인 번호를 찾을 수 없습니다. 번호를 확인하신 후 다시 시도해 주세요. 처음 예약 시 저희가 보내드린 이메일에서 번호를 확인하실 수 있습니다.',
  ResponseInvalidItineraryNotFound:
    '해당 일정 번호 또는 확인 번호를 찾을 수 없습니다. 번호를 확인하신 후 다시 시도해 주세요. 처음 예약 시 저희가 보내드린 이메일에서 번호를 확인하실 수 있습니다.',
  ResponseInvalidTripMoreThanSevenDays: '요청을 처리할 수 없습니다.',
  ResponseInvalidTripIsLcc:
    '항공사에서 모든 취소를 처리합니다. 해당 항공사에 직접 문의해 주세요. 자세한 내용을 보려면 계정에 로그인하고 온라인 일정을 확인해 주세요. 현재 진행 중인 취소가 일정에 취소됨 상태로 표시되는 데 최대 72시간이 소요될 수 있습니다.',
  ResponseInvalidTripIsTicketless:
    '항공사에서 모든 취소를 처리합니다. 해당 항공사에 직접 문의해 주세요. 자세한 내용을 보려면 계정에 로그인하고 온라인 일정을 확인해 주세요. 현재 진행 중인 취소가 일정에 취소됨 상태로 표시되는 데 최대 72시간이 소요될 수 있습니다.',
  ResponseInvalidItinerary:
    '해당 일정 번호를 인식할 수 없습니다. 다시 시도해 주세요.',
  ResponseInvalidStatus: '오류가 발생한 것 같습니다. 다시 시도해 주세요.',
  ResponseInvalidEmail:
    '해당 이메일 주소를 인식할 수 없거나 이 일정에 대한 이메일 주소와 일치하지 않습니다. 예약 시 사용한 이메일인지 확인해 주세요.',
  ResponseInvalidPhone:
    '해당 전화번호를 인식할 수 없습니다. 예약 시 사용한 번호인지 확인해 주세요.',
  ResponseTripHasLccFlight:
    '일부 예약은 취소할 수 있지만 모든 예약에 대한 취소는 불가능합니다. 저희가 취소할 수 없는 예약에 대해서는 해당 공급업체에 직접 문의해 주세요. 온라인 일정에서 어떤 예약을 취소해야 하는지 확인하실 수 있습니다. 현재 진행 중인 취소가 일정에 취소됨 상태로 표시되는 데 최대 72시간이 소요될 수 있습니다.',
  ResponseErrorTripWithin24Hrs:
    '여행 날짜까지 24시간이 채 남지 않아 취소를 처리할 수 없습니다. 자세한 내용을 보려면 계정에 로그인하고 온라인 일정을 확인해 주세요.',
  ResponseInvalidTripInCruise:
    '이 양식은 크루즈를 취소하는 데 사용하실 수 없습니다. 계정에 로그인하여 일정에서 온라인으로 취소해 주세요.',
};

export default koKr;
